// Frontend Supabase client for AUTH ONLY (login, signup, OAuth, password reset,
// session). Uses the public anon key — which is safe to ship to the browser and
// is protected by Row Level Security. The service-role key is NEVER used here.
//
// Requires build-time env vars (set in Netlify, values are public/anon):
//   REACT_APP_SUPABASE_URL
//   REACT_APP_SUPABASE_ANON_KEY
//
// If they are absent the client is null and the UI degrades gracefully to a
// "sign-in unavailable" message instead of crashing.
import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase = isSupabaseConfigured
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,      // keep the customer signed in across refreshes
        autoRefreshToken: true,
        // OFF, deliberately. A PKCE code and its verifier are single-use, and
        // this library will spend both the moment the client is constructed:
        // createClient -> new GoTrueClient -> initialize() -> _initialize()
        // -> _getSessionFromURL('pkce'), which exchanges the code and DELETES
        // sb-<ref>-auth-token-code-verifier.
        //
        // exchangeCodeForSession() opens with `await this.initializePromise`,
        // so our explicit call cannot run until that has finished — it always
        // arrives second, to a verifier that is already gone, and fails with
        // AuthPKCECodeVerifierMissingError. Two consumers, one code.
        //
        // lib/authCallback is the one owner now. It handles every PKCE return
        // this app receives — Google sign-in, email confirmation and password
        // recovery — and reports the redirect type so recovery still works.
        detectSessionInUrl: false,
        flowType: "pkce",
      },
    })
  : null;
